import React, { ReactNode, useEffect } from "react";
import { AuthenticationProvider } from "../shared/contexts";
import { OAuth2Provider } from "../shared/contexts";
import { AccountProvider } from "../shared/contexts";
import { ThemeProvider } from "../shared/contexts";
import { RenderOAuth2 } from "../shared/contexts";
import { RecaptchaProvider } from "../shared/contexts/RecaptchaContext";
import { errorHandler } from "../shared/utils/ErrorHandler";
import { cleanupExpiredSessions } from "../shared/utils/storage/sessionFormStorage";

interface AppProvidersProps {
  children: ReactNode;
}

export const AppProviders: React.FC<AppProvidersProps> = ({ children }) => {
  useEffect(() => {
    // Initialize global error handler
    errorHandler.initialize();
    
    // Clean up expired session form data on app initialization
    cleanupExpiredSessions();

    // Cleanup on unmount
    return () => {
      errorHandler.destroy();
    };
  }, []);

  return (
    <ThemeProvider>
      <RecaptchaProvider>
        <OAuth2Provider>
          <RenderOAuth2>
            <AuthenticationProvider>
              <AccountProvider>
                {children}
              </AccountProvider>
            </AuthenticationProvider>
          </RenderOAuth2>
        </OAuth2Provider>
      </RecaptchaProvider>
    </ThemeProvider>
  );
};
